import { useState, useEffect } from 'react';
import { Space } from 'antd';
import type { RadioChangeEvent, TabsProps } from 'antd';
import { Radio } from 'antd';
import { StyledTabGroup } from './index.style';

type AppTabGroupContainerPropsTypes<K extends string> = {
  items: TabsProps['items'];
  defaultActiveTab: K;
  handleTabGroupChange: (key: K) => void;

  [x: string]: any;
};
const AppTabGroupContainer = <K extends string>({
  items,
  defaultActiveTab,
  handleTabGroupChange,
}: AppTabGroupContainerPropsTypes<K>) => {
  const [activeTab, setActiveTab] = useState<K>(defaultActiveTab);

  useEffect(() => {
    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab]);

  const onChange = (e: RadioChangeEvent) => {
    setActiveTab(e.target.value as K);
    handleTabGroupChange(e.target.value as K);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <StyledTabGroup>
        <Radio.Group value={activeTab} onChange={onChange}>
          {items?.map((item) => (
            <Radio.Button key={item.key} value={item.key}>
              {item.label}
            </Radio.Button>
          ))}
        </Radio.Group>
      </StyledTabGroup>
    </Space>
  );
};

export default AppTabGroupContainer;
